import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'grid',
        name: 'ADUser',
        title: i18n.t('user.form.ADUser'),
        rules: {},
        modal: ['username'],
        data: ['sAMAccountName'],
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Users/forms/LDAPDataList.js